import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { ContainPopover } from '../../interfaces/contain-popover.interface';

import { TranslateService } from '../../services/translate/translate.service';

@Component({
  selector: 'mg-translate',
  templateUrl: './translate.component.html',
  styleUrls: ['./translate.component.scss'],
})
export class TranslateComponent implements OnInit {
  @Output() closeTraslate: EventEmitter<any> = new EventEmitter();
  @Input() figure = true;
  language!: string;
  some_text ='';
  inside = false;
  constructor(private translate: TranslateService) {}

  ngOnInit(): void {}

  @HostListener("click")
  clicked() {
    this.inside = true;
  }


  @HostListener("document:click")
  clickedOut() {
    this.some_text = this.inside ? "Event Triggered" : "Event Triggered Outside Component";
    if(!this.inside){
      this.closeTraslate.emit(this.inside);
    }
    this.inside = false;
  }

  /**
   * Change language and emit
   */
  changeLanguage(item: ContainPopover) {
    const language = item.value || 'en';
    this.language = language;
    this.translate.update(language);
  }
}
